import { useEffect, useState } from "react";

/**
 * Delays showing a loading state by `delayMs` milliseconds.
 *
 * Why: if data arrives in under `delayMs`, the skeleton never renders at all,
 * eliminating the flash of loading-state → real-content that users see as
 * "jumping" on page refresh.
 *
 * Usage:
 *   const showSkeleton = useDelayedLoading(isLoading);
 *   if (showSkeleton) return <Skeleton />;
 */
export function useDelayedLoading(loading: boolean, delayMs = 150): boolean {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!loading) {
      setShow(false);
      return;
    }
    const id = setTimeout(() => setShow(true), delayMs);
    return () => clearTimeout(id);
  }, [loading, delayMs]);

  return show;
}
